namespace SolovisGateway.Admin.Organizations {

    export interface OrgRemoveDomainDialogOptions {
        domain: string;
        onRemove?: () => void;
        onCancel?: () => void;
    }

    export class OrgRemoveDomainDialog {

        private _options: OrgRemoveDomainDialogOptions;

        private _dialog: any;
        private _confirmContainer: JQuery;
        private _loaderContainer: JQuery;

        constructor(options: OrgRemoveDomainDialogOptions) {
            this._options = options;
        }

        public show() {
            var body = $("<div>").css({ "padding": "0 15px" });

            var confirmContainer = $("<div>");
            body.append(confirmContainer);
            this._confirmContainer = confirmContainer;

            confirmContainer.append($("<p>").append(
                $("<strong>").text(this._options.domain),
                $("<span>").text(
                    " is not federated, because this connection is not live. Removing it does not change how anyone signs in."
                )
            ));

            confirmContainer.append($("<p>").append(
                $("<span>").text("If you enable this connection later, "),
                $("<strong>").text(this._options.domain),
                $("<span>").text(" will not be included unless you add it back.")
            ));

            var loaderContainer = $("<div>")
                .css({ "position": "relative", "height": "150px", "display": "none" });
            Solovis.UI.StockAnimations.createSpinningCircles({
                diameter: "60px",
                top: "50%",
                left: "50%",
                showShadow: true
            }).appendTo(loaderContainer);
            body.append(loaderContainer);
            this._loaderContainer = loaderContainer;

            this._dialog = new (Solovis as any).UI.Dialog({
                container: body,
                title: "Remove " + this._options.domain + " from this connection?",
                modal: true,
                autoOpen: true,
                center: true,
                destroyOnClose: true,
                actions: ["Close"],
                width: 600,
                buttons: this._buildDefaultButtons()
            });
        }

        public close() {
            this._dialog.close();
        }

        public resetToConfirm() {
            this._loaderContainer.hide();
            this._confirmContainer.show();
            this._dialog.updateButtons(this._buildDefaultButtons());
        }

        private _buildDefaultButtons() {
            var self = this;
            return [
                {
                    label: "Remove Domain",
                    click: function () {
                        self._attemptRemove();
                    }
                },
                {
                    label: "Cancel",
                    click: function () {
                        self._dialog.close();
                        if (self._options.onCancel) {
                            self._options.onCancel();
                        }
                    }
                }
            ];
        }

        private _attemptRemove() {
            this._confirmContainer.hide();
            this._loaderContainer.show();
            this._dialog.updateButtons([]);

            if (this._options.onRemove) {
                this._options.onRemove();
            }
        }
    }
}
